/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React, { Component } from 'react'
import './StaffRow.css'

export default class StaffRow extends Component {

    getAccountStatus(user) {
        if(user.invite_status === 'pending') {
            return 'Pending...'
        }

        let value = user.is_owner === '1' ? 'Owner' : 'Member'

        if ( this.props.currentUser && this.props.currentUser.user_id === user.user_id) {
            value += ' (you)'
        }

        return value
    }

    render() {
        const user = this.props.user

        return (
            <div className="StaffRow trc-grid">
                <div className="col m-f2">
                    <a href={ `#${this.props.location.pathname.replace(/\/magic.*$/gi, '')}/${user.user_id}/edit` }>
                        {user.first_name}
                        &nbsp;
                        {user.last_name}
                    </a>
                </div>
                <div className="col email m-f3">
                    { user.email ? user.email : user.masked_email }
                </div>
                <div className="col status m-f1">
                    { this.getAccountStatus(user) }
                </div>
            </div>
        )
    }

}

